const prosthetics = {
  hero: {
    titlePrefix: "Съвременни",
    titleAccent: "Дентални Протези",
    titleSuffix: "и Решения",
    description:
      "Възстановете усмивката и денталната си функция с нашите персонализирани, висококачествени протезни решения, проектирани да изглеждат, усещат се и функционират като естествени зъби.",
    ctas: {
      primary: "Запишете Консултация",
      secondary: "Научете за Процеса",
    },
    imageAlt: "Дентални протези, включително подвижни и мостове",
    callout: {
      title: "Естествен Вид",
      body:
        "Нашите протезни решения са изработени така, че да съответстват перфектно на естествените ви зъби",
    },
  },
  benefits: {
    heading: "Предимства на Денталните Протези",
    intro:
      "Открийте защо пациентите избират нашите протезни решения за възстановяване на усмивката",
    items: [
      {
        title: "Естествена Естетика",
        description:
          "Нашите протези са проектирани да изглеждат неразличими от естествените зъби, възстановявайки увереността в усмивката ви.",
      },
      {
        title: "Подобрена Функция",
        description:
          "Насладете се отново на естественото хранене, говорене и усмихване с правилно поставени и функционални протезни зъби.",
      },
      {
        title: "По-добро Орално Здраве",
        description:
          "Протезите помагат за предотвратяване на изместването на останалите зъби и поддържат структурата на лицето и целостта на костите.",
      },
      {
        title: "Дълготрайни Резултати",
        description:
          "Нашите висококачествени материали и експертна изработка гарантират, че вашите протези ще ви служат дълги години.",
      },
      {
        title: "Превантивна Защита",
        description:
          "Денталните протези помагат за защита на останалите естествени зъби от прекомерно износване и напрежение.",
      },
      {
        title: "Персонализирани Решения",
        description:
          "Всяка протеза е изработена по поръчка според вашите специфични нужди, осигурявайки перфектно прилягане и максимален комфорт.",
      },
    ],
    bottomLinePrefix: "Готови ли сте да възстановите усмивката си?",
    bottomLineCta: "Запишете консултация за протези днес",
  },
  process: {
    heading: "Процесът на Протезиране",
    intro: "Нашият детайлен подход осигурява отлични резултати",
    steps: [
      {
        title: "Първоначална Консултация",
        description:
          "Наш специалист ще оцени денталното ви състояние, ще обсъди вашите нужди и ще обясни наличните протезни опции.",
      },
      {
        title: "Цялостен Преглед",
        description:
          "Ще направим задълбочена оценка, включително дигитални скенери и рентгенови снимки, за да създадем прецизен план за лечение.",
      },
      {
        title: "Планиране на Лечението",
        description:
          "Въз основа на прегледа ви, ще разработим персонализирано протезно решение, съобразено с вашите специфични нужди.",
      },
      {
        title: "Отпечатъци и Дизайн",
        description:
          "Вземаме детайлни отпечатъци, за да гарантираме, че вашите протези ще прилягат перфектно и ще съответстват на естествените ви зъби.",
      },
      {
        title: "Изработка и Поставяне",
        description:
          "Вашите персонализирани протези се изработват в нашата лаборатория и след това се поставят прецизно за комфорт и функционалност.",
      },
      {
        title: "Проследяване и Поддръжка",
        description:
          "Предоставяме инструкции за текуща грижа и планираме редовни прегледи, за да осигурим дълготрайни резултати.",
      },
    ],
  },
  faq: {
    heading: "Често Задавани Въпроси",
    intro: "Всичко, което трябва да знаете за денталните протези",
    items: [
      {
        question: "Какви видове дентални протези предлагате?",
        answer:
          "Предлагаме пълна гама от дентални протези, включително фиксирани протези (корони, мостове и протези върху импланти) и подвижни протези (цели и частични). Нашите специалисти ще ви помогнат да определите коя опция е най-подходяща за вашите специфични нужди и предпочитания.",
      },
      {
        question: "Колко дълго издържат денталните протези?",
        answer:
          "Продължителността на живота на денталните протези варира в зависимост от вида и използваните материали. При правилна грижа и поддръжка, короните и мостовете могат да издържат 10-15 години, докато висококачествените подвижни протези обикновено издържат 5-7 години. Протезите върху импланти могат да издържат 15+ години или дори цял живот при отлична устна хигиена.",
      },
      {
        question: "Ще изглежда ли естествено моята дентална протеза?",
        answer:
          "Абсолютно! Гордеем се с изработката на протези, които са практически неразличими от естествените зъби. Нашата съвременна дигитална технология за изображения и висококачествени материали ни позволяват да съчетаем цвета, формата и прозрачността на вашите естествени зъби, осигурявайки безупречен и естествен вид.",
      },
      {
        question: "Трудно ли е да се адаптирам към носенето на дентални протези?",
        answer:
          "Обикновено има период на адаптация при първоначалното получаване на дентални протези. Повечето пациенти се адаптират в рамките на няколко седмици, докато свикнат да говорят и да се хранят с новите си зъби. Нашият екип предоставя цялостни насоки и подкрепа през този преходен период, за да осигури максимален комфорт.",
      },
      {
        question: "Как да се грижа за моите дентални протези?",
        answer:
          "Инструкциите за грижа варират в зависимост от вида на протезата. Като цяло, фиксираните протези изискват редовно четкане, почистване с конец и професионално почистване. Подвижните протези трябва да се почистват ежедневно със специални разтвори и четки и да се съхраняват правилно, когато не се използват. Предоставяме подробни инструкции за грижа, съобразени с вашата конкретна протеза.",
      },
      {
        question: "Покриват ли се денталните протези от застраховка?",
        answer:
          "Много дентални застрахователни планове предоставят частично покритие за протезни лечения, обикновено категоризирани като основни възстановителни процедури. Процентите на покритие варират според застрахователя и плана. Нашият административен екип може да помогне за проверка на вашите застрахователни обезщетения и да обсъди възможности за финансиране, за да направи лечението ви достъпно.",
      },
    ],
    bottomLine: "Имате още въпроси за денталните протези?",
    cta: "Свържете се с Нас",
  },
};

export default prosthetics;

